import { FlexVerticalAligned } from "../../../common/components/styled/styled";
import InfoTooltip from "../../../common/components/functional/InfoTooltip/InfoTooltip";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

const TalentFiltersInfoRow = () => {
  const { t } = useTranslation();
  const info = t("talentProfile:talentFiltersInfo");

  return (
    <Grid item xs={12} justifyItems="flex-end">
      <FlexVerticalAligned gap="4px">
        <InfoTooltip
          title={info}
          placement="bottom-end"
          slotProps={{
            tooltip: { sx: { maxWidth: "500px", whiteSpace: "pre-line" } },
          }}
          style={{
            width: "18px",
            height: "18px",
            margin: "0px 4px 2px 0px",
            zIndex: 100,
          }}
        />
      </FlexVerticalAligned>
    </Grid>
  );
};

export default TalentFiltersInfoRow;
